import './dropdown.less';

import { useContext } from 'react';
import { useEffect }  from 'react';
import { useRef }     from 'react';
import classnames     from 'classnames';
import React          from 'react';
import useBoolean     from '../hooks/use_boolean';


const DropdownContext = React.createContext();

export default function Dropdown({ children, className }) {
  const [ dropdownIsOpen, openDropdown, closeDropdown, toggleDropdown ] = useBoolean(false);

  const contextValue = {
    dropdownIsOpen,
    openDropdown,
    closeDropdown,
    toggleDropdown
  };

  const classNames = classnames('dropdown', className, {
    'dropdown-open': dropdownIsOpen
  });

  return (
    <DropdownContext.Provider value={contextValue}>
      <div className={classNames}>
        <DropdownOverlay/>
        <div className="dropdown-container">
          {children}
        </div>
      </div>
    </DropdownContext.Provider>
  );
}


function DropdownOverlay() {
  return (
    <div className="dropdown-overlay"/>
  );
}


function DropdownHeader({ children }) {
  const { toggleDropdown } = useContext(DropdownContext);
  return (
    <div className="dropdown-header" onClick={toggleDropdown}>
      {children}
    </div>
  );
}
Dropdown.Header = DropdownHeader;


function DropdownContent({ children }) {
  const { dropdownIsOpen, closeDropdown } = useContext(DropdownContext);
  const ref                               = useRef();

  useEffect(function closeDropdownWhenClickedOutside() {
    function clickListener(event) {
      const clickedOutside = !ref.current.contains(event.target);
      if (clickedOutside) {
        event.stopPropagation();
        closeDropdown();
      }
    }

    if (dropdownIsOpen)
      document.body.addEventListener('click', clickListener);

    return () => {
      document.body.removeEventListener('click', clickListener);
    };
  }, [ closeDropdown, dropdownIsOpen ]);

  return (
    <div className="dropdown-content" ref={ref}>
      {children}
    </div>
  );
}
Dropdown.Content = DropdownContent;


function DropdownItem({ children, onClick = () => {}, disabled, className }) {
  const { closeDropdown } = useContext(DropdownContext);
  const classNames        = classnames('dropdown-item', className);

  function onClickItem() {
    onClick();
    closeDropdown();
  }
  return (
    <div className={classNames} onClick={onClickItem} disabled={disabled}>
      {children}
    </div>
  );
}
Dropdown.Item = DropdownItem;

Dropdown.Context = DropdownContext;
